import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, " Create a Shipment ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, " Mark the following items as shipped to JC Jewels. Please add a tracking reference and attach an invoice. ")
], -1)
const _hoisted_3 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_4 = { class: "flex flex-col flex-1 truncate" }
const _hoisted_5 = { class: "font-semibold text-gray-900 text-sm" }
const _hoisted_6 = { class: "text-gray-600 text-sm" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = { class: "space-y-2 pb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "theme",
    for: "tracking"
  }, "Shipping Code / Tracking Reference"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Required")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "theme" }, "Invoice", -1)
const _hoisted_13 = { class: "mt-2 border-t pt-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Confirm Items are Shipped ")

import Modal from "@/components/Modal.vue";
import { IOrder } from "@/utils/IOrder";
import { computed, PropType, ref } from "vue";
import { XIcon } from "@heroicons/vue/solid";
import Input from "@/components/Input.vue";
import TextInput from "@/components/TextInput.vue";
import FileInput from "@/components/FileInput.vue";
import Button from "@/components/Button.vue";
import { useFulfilment } from "@/composables/fulfilment";
import { useVendor } from "@/composables/vendor";
import { every, isNil } from "lodash";
import { useOrders } from "@/composables/orders";
import Spinner from "@/components/Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  open: Boolean,
  selected: {
    type: Array as PropType<IOrder[]>,
    required: true,
  },
},
  emits: ["update:selected", "close"],
  setup(__props, { emit }) {

const props = __props





const { client } = useFulfilment();
const { currentVendor } = useVendor();
const { refresh } = useOrders();

const isCreatingShipment = ref(false);

const files = ref(
  [] as { name: string; size: number; file: File; url?: string }[]
);

const onRemove = (order: IOrder) => {
  let selected = props.selected.filter((o) => o.id !== order.id);
  emit("update:selected", selected);
  if (selected.length === 0) emit("close");
};

const trackingRef = ref(null);

const isValidTrackingRef = (value: string) => {
  if (!value) return false;

  // let r = new RegExp("^[\d\s]+$", "i");
  let r = /^[a-zA-Z\d\s]+$/;
  let t = r.test(value);
  console.log({ r, m: value.match(r), value, t });
  return t;
};

const canCreateShipment = computed(() => {
  if (isCreatingShipment.value) return false;

  if (!trackingRef.value) return false;

  if (!isValidTrackingRef(trackingRef.value)) return false;

  if (files.value.length > 0) {
    // is every file uploaded?
    if (!every(files.value, (file) => !isNil(file.url))) {
      return false;
    }
  }

  return true;
});

const doCreateShipment = async () => {
  if (isCreatingShipment.value) return;

  console.log("doCreateShipment", {
    trackingRef,
    files,

    selected: props.selected,
  });

  let items = [...props.selected];

  isCreatingShipment.value = true;

  try {
    let response = await client.value!.post("/fulfilment/shipments/create", {
      supplier: currentVendor.value!.shortname,
      records: [
        {
          items: items.map((val) => val.id),
          trackingRef: trackingRef.value,
          status: "SENT",
          supplierAttachments: files.value.map((file) => ({ url: file.url })),
        },
      ],
    });

    await client.value!.post(`/fulfilment/items/update`, {
      supplier: currentVendor.value!.shortname,
      records: [
        ...items.map((item) => ({
          id: item.id,
          update: { supplierStatus: "FULFILLED" },
        })),
      ],
    });

    await refresh();

    emit("update:selected", []);
    emit("close");
  } catch (error) {
    window.alert(error);
  } finally {
    isCreatingShipment.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: __props.open,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    class: "max-w-md p-4"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selected, (order) => {
            return (_openBlock(), _createElementBlock("li", {
              key: order.id,
              class: "py-4 flex"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(order.name), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(order.supplier) + " " + _toDisplayString(order.origin) + " " + _toDisplayString(order.supplierRef), 1)
              ]),
              _createElementVNode("button", {
                onClick: ($event: any) => (onRemove(order)),
                class: "flex items-center ml-2 px-2 py-1 hover:bg-red-100 text-gray-300 hover:text-red-500 transition-colors border-l border-gray-200 hover:border-red-500"
              }, [
                _createVNode(_unref(XIcon), { class: "w-6 h-6" })
              ], 8, _hoisted_7)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(doCreateShipment, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createVNode(TextInput, {
                id: "tracking",
                modelValue: trackingRef.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((trackingRef).value = $event)),
                validate: isValidTrackingRef,
                class: "mt-1"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_12,
              _createVNode(FileInput, {
                class: "mt-1",
                modelValue: files.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((files).value = $event)),
                prompt: "Upload a copy of the invoice"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(Button, {
              class: "w-full flex justify-center items-center disabled-opacity",
              type: "submit",
              disabled: !_unref(canCreateShipment)
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                (isCreatingShipment.value)
                  ? (_openBlock(), _createBlock(Spinner, {
                      key: 0,
                      class: "w-4 h-4 ml-2"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 40, _hoisted_9)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})